<template>
  <v-app light id="app">
    <vue-extend-layouts></vue-extend-layouts>
    <global></global>
  </v-app>
</template>

<script>
import global from './components/global.vue'
import VueExtendLayouts from 'vue-extend-layout'
export default {
  name: 'full',
  components: {
    global,
    VueExtendLayouts
  }
}
</script>
<style lang="scss" scoped>
  #app {
    height: 100vh;
    width: 100%;
    display: flex;
  }
</style>
